let AbstractLogicalGeometryOperationResult = require('./abstractLogicalOperationResult');

/**
 * Класс IsOverlappedResult определяет структуру результата логической проверки на перекрытие одного объекта другим
 * @extends AbstractLogicalGeometryOperationResult
 */
class IsOverlappedResult extends AbstractLogicalGeometryOperationResult {
  /**
   * Создает экземпляр класса IsOverlappedResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IsOverlappedResult";
  }
}

module.exports = IsOverlappedResult;